<script>
    import {debounce, chunk, range} from 'lodash-es';
    import {onMount} from 'svelte';
    import { addFormModal } from '../Forms/ModalFormManager.svelte';

    import {downloadFile} from '../Utilities/util';

    import Sortable from 'sortablejs/modular/sortable.core.esm.js';

	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

    export let sortFields = [];
    export let tableData = [];
    export let tableClass = "sortTable";

    export let paged = true;
    export let page = 1;
    export let page_size = 10;

    export let actionsWidth = 175;

    export let defaultSort = false;

    export let ORM = false;
    export let rowKey = ORM ? "id" : "_rev";
    export let addedColumns = 0
    export let sortable = false;

    let filters = {};

    let items_tbody;

    let sortColumns = {};
    let sortedFilteredData = [];

    export let showHideFields = true;
    let hiddenFields = sortFields.filter(field => field.default_hidden).map(field => field.field);

    let keyedSortFields = {};
    let sortOrder = [];

    let num_pages = 1;
    let full_span = 1;

    let debug = JSON.parse(window.localStorage.getItem("katana.debug"));

    function buildKeyedSortFields(sortFields, addedColumns) {
        keyedSortFields = {};

        for (let field of sortFields) {
            keyedSortFields[field.field] = field;
        }

        full_span = sortFields.length + addedColumns - hiddenFields.length;
        if ($$slots.rowActions) {
            full_span += 1;
        }
    }

    async function sort(list, sorter, filters) {
        if (!list) {
            list = [];
        }
        let copy = list.filter((item) => {
            if (ORM) item = item.details;

            for (let field of sortFields) {
                if (!field.filterFunc) {
                    field.filterFunc = (filter, item) => {

                        if (field.type == "checkbox") {
                            // use !! to cast undefined to false
                            return !!item[field.field] === filter
                        }

                        if (item[field.field] == undefined) return false;

                        if (field.type == "tags") {
                            for (let tag of item[field.field]) {
                                if (tag.toLowerCase().includes(filter.toLowerCase())) {
                                    return true
                                }
                            }
                            return false;
                        } else if (field.type == "references") {
                            for (let reference of item[field.field]) {
                                if (reference.control && reference.control.toLowerCase().includes(filter.toLowerCase())) {
                                    return true
                                }
                            }
                            return false
                        }

                        let inverse = filter.startsWith("-");

                        if (inverse) {
                            return !item[field.field].toLowerCase().includes(filter.substring(1).toLowerCase())
                        } else {
                            return item[field.field].toLowerCase().includes(filter.toLowerCase())
                        }

                    }
                }
                try {
                    if (filters[field.field] != undefined && !field.filterFunc(filters[field.field], item)) {
                        return false;
                    }
                } catch (e) {
                    console.error(e);
                    return false;
                }
            }
            return true;
        });

        copy.sort(sorter);

        if (paged) {
            let pages = chunk(copy, page_size);
            num_pages = pages.length

            if (page > pages.length) {
                page = 1;
            }

            sortedFilteredData = pages.length ? pages[page - 1] : [];
        } else {
            sortedFilteredData = copy;
        }
    }

    function simpleSort(column) {
        return (a, b, desc) => {
            if (ORM) {
                a = a.details;
                b = b.details;
            }

            if (a[column] > b[column]) {
                return desc ? 1 : -1;
            }
            if (b[column] > a[column]) {
                return desc ? -1 : 1;
            }
            return 0;
        }
    }

    function sorter(columns) {
        if (!columns) return 0;

        return (a, b) => {
            for (let column of sortOrder) {
                let sort_func = keyedSortFields[column].sort_func || simpleSort(column);
                let order = sort_func(a, b, columns[column]);
                if (order) {
                    return order
                }
            }
            return 0;
        }
    }

    function toggleSortColumn(column) {
        // remove from sort order
        sortOrder = sortOrder.filter(c => c != column);

        if (sortColumns[column] == true) {
            sortColumns[column] = false;
            sortOrder.push(column);
        } else {
            sortColumns[column] = true;
            sortOrder.push(column);
        }

        sortColumns = sortColumns;
    }

    function deleteSortColumn(column) {
        // remove from sort order
        sortOrder = sortOrder.filter(c => c != column);
        delete sortColumns[column];

        sortColumns = sortColumns;
    }

    function setPage(no) {
        return () => {
            page = no;
        }
    }

    function page_iterator() {
        let pages = [];

        if (page > 1) {
            pages.push({
                label: "«",
                func: setPage(page - 1)
            })
        }

        let start = page - 3 > 1 ? page - 3 : 1;
        let end = page + 3 < num_pages + 1 ? page + 3 : num_pages + 1;

        if (start > 1) {
            pages.push({
                label: "1",
                func: setPage(1)
            });
            pages.push({
                label: '...'
            })
        }

        for (let p of range(start, end)) {
            pages.push({
                label: p,
                func: setPage(p)
            })
        }

        if (end < num_pages) {
            pages.push({
                label: '...'
            })

            pages.push({
                label: num_pages,
                func: setPage(num_pages)
            });
        } else if (end == num_pages) {
            pages.push({
                label: num_pages,
                func: setPage(num_pages)
            });
        }

        if (page < num_pages) {
            pages.push({
                label: "»",
                func: setPage(page + 1)
            })
        }

        return pages
    }

    function getField(row, field) {
        let value;

        if (ORM) {
            value = row.details[field]
        } else {
            value = row[field]
        }

        if (value === undefined) {
            value = "";
        }

        return value;
    }

    function manageHidden() {
        addFormModal({
            title: "Manage Hidden Fields",
            data: {
                hidden: hiddenFields
            },
            fields: [
                {
                    name: "hidden",
                    label: "Hidden Fields",
                    type: "select",
                    multiple: true,
                    choices: {
                        static: sortFields.map(f => f.field)
                    }
                }
            ]
        }).then(data => {
            hiddenFields = data.hidden;
        })
    }

    function dumpData() {
        let data = JSON.stringify(tableData);

        downloadFile(data, 'export.json');
    }

    const deSort = debounce(sort, 150, {
        leading: true
    });
    $: hiddenFields, buildKeyedSortFields(sortFields, addedColumns);
    $: page_size, deSort(tableData, sorter(sortColumns), filters, page);

    onMount(() => {
        if (defaultSort) {
            sortColumns[defaultSort] = true;
            toggleSortColumn(defaultSort);
        }

        if (sortable) {
            Sortable.create(items_tbody, {
                onEnd: (evt) => {
                    dispatch("sortEnd", evt);
                }
            })
        }
    })
</script>
<slot></slot>
<table class="table is-striped is-fullwidth is-bordered {tableClass}">
    <thead>
        {#if (paged && num_pages > 1) || showHideFields}
        <tr>
            <td colspan="{full_span}">
                <div class="level">
                    <div class="level-left">
                        {#if showHideFields}
                            <div class="level-item">
                                <button class="button" on:click={manageHidden}>Manage Hidden Fields ({hiddenFields.length})</button>
                            </div>
                            <slot name="headerActions" />
                        {/if}
                    </div>

                    {#if (paged && num_pages > 1)}
                        <div class="level-right">
                            <div class="select level-item">
                                <select bind:value={page_size}>
                                    <option value={10}>10 per page</option>
                                    <option value={20}>20 per page</option>
                                    <option value={50}>50 per page</option>
                                    <option value={100}>100 per page</option>
                                </select>
                            </div>

                            <span class="buttons has-addons level-item">
                                {#each page_iterator(page, num_pages) as p}
                                    {#if p.func}
                                        <span class="button is-narrow" on:click={p.func} class:is-active={p.label == page}>
                                            {p.label}
                                        </span>
                                    {:else}
                                        <span class="button is-narrow">
                                            {p.label}
                                        </span>
                                    {/if}
                                {/each}
                            </span>
                        </div>
                    {/if}
                </div>
            </td>
        </tr>
        {/if}
        <tr>
            {#if $$slots.prependHeaders}
                <slot name="prependHeaders"></slot>
            {/if}
            {#each sortFields as field}
                {#if !hiddenFields.includes(field.field) }

                    <th {...field.attrs} class="pointer" on:click={() => toggleSortColumn(field.field)}>
                        {field.label}
                        <sup class:hidden={sortColumns[field.field] == undefined}>
                            {sortOrder.indexOf(field.field) + 1}
                        </sup>
                        <span class:hidden={sortColumns[field.field] == undefined} class="sort_order">
                            <span>{@html sortColumns[field.field] ? "&#9650": "&#9660;"}</span>
                            <span class="delete is-small" on:click|stopPropagation={() => deleteSortColumn(field.field)}></span>
                        </span>
                    </th>

                {/if}
            {/each}
            {#if $$slots.appendHeaders}
                <slot name="appendHeaders"></slot>
            {/if}
            {#if $$slots.rowActions}
                <th width="{actionsWidth}px">Actions</th>
            {/if}
        </tr>
    </thead>
    <tfoot>
        {#if $$slots.footerActions}
        <tr>
            <td colspan="{full_span}">
               <slot name="footerActions"></slot>
            </td>
        </tr>
        {/if}
        {#if paged && num_pages > 1}
        <tr>
            <td colspan="{full_span}">
                <span class="buttons has-addons is-right">
                    {#each page_iterator(page, num_pages) as p}
                        {#if p.func}
                        <span class="button is-narrow" on:click={p.func} class:is-active={p.label == page}>
                            {p.label}
                        </span>
                        {:else}
                            <span class="button is-narrow">
                                {p.label}
                            </span>
                        {/if}
                    {/each}
                </span>
            </td>
        </tr>
        {/if}
    </tfoot>
    <tbody>
        <tr>
            {#each sortFields as field}
                {#if !hiddenFields.includes(field.field) }
                    <td
                        class:is-v-centered={field.type == "checkbox"}
                        class:is-h-centered={field.type == "checkbox"}
                    >
                        <div class="control has-icons-right">
                            {#if field.type == "checkbox" }
                                <label class="checkbox">
                                    <input type="checkbox" bind:checked={filters[field.field]} indeterminate={filters[field.field] == undefined}>
                                </label>
                            {:else}
                                <input class="input" type="text" placeholder="Search" bind:value={filters[field.field]}>
                            {/if}
                            <span class="icon is-small is-right">
                                <span class="delete is-small" on:click={() => filters[field.field] = undefined}></span>
                            </span>
                        </div>
                    </td>
                {/if}
            {/each}

            {#each (new Array(parseInt(addedColumns))) as i}
                <td></td>
            {/each}

            {#if $$slots.rowActions}
            <td>
                <slot name="filterActions"></slot>
            </td>
            {/if}
        </tr>
        <slot name="topRow"></slot>
        </tbody>
        <tbody bind:this={items_tbody}>
        {#each sortedFilteredData as row (row[rowKey])}
            <tr>
                {#if $$slots.prependColumns}
                    <slot name="prependColumns" row={row}></slot>
                {/if}

                {#each sortFields as field}
                    {#if !hiddenFields.includes(field.field) }
                        <td
                            {...field.rowAttrs}
                            class:is-v-centered={field.vCenter || field.type == "checkbox"}
                            class:is-h-centered={field.hCenter || field.type == "checkbox"}
                            data-field="{ORM ? row.details[field.dataAttr] : row[field.dataAttr]}"
                        >
                            {#if field.tags || field.type == "tags" }
                                <span class="tags">
                                    {#each getField(row, field.field) || [] as tag}
                                        <span class="tag is-info is-light">{tag}</span>
                                    {/each}
                                </span>
                            {:else if field.component}
                                <svelte:component this={field.component} value={getField(row, field.field)} {...field.componentProps} />
                            {:else if field.formatter}
                                <span class="pre">{field.formatter(getField(row, field.field), row)}</span>
                            {:else if field.type == "checkbox"}
                                <input type="checkbox" checked={getField(row, field.field)} on:click|preventDefault disabled="disabled">
                            {:else}
                                <span class="pre">{getField(row, field.field)}</span>
                            {/if}
                        </td>

                    {/if}
                {/each}
                {#if $$slots.appendColumns}
                    <slot name="appendColumns" row={row}></slot>
                {/if}
                {#if $$slots.rowActions}
                <td>
                    <slot name="rowActions" row={row}></slot>
                </td>
                {/if}
            </tr>
            <slot name="customRow" row={row}></slot>
        {/each}
        <slot name="bottomRow"></slot>
    </tbody>
</table>

{#if debug}
    <button on:click={dumpData}>Debug Dump</button>
{/if}

<style>
    .sort_order.hidden {
        display: none;
    }

    .sort_order .delete{
        float: right;
    }

    .pre {
        white-space: pre-wrap;
    }
</style>